import * as React from "react";

import { cn } from '../../lib/utils';

type Props = {
  title: string;
  description?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export default function SectionHeading({
  title,
  description,
  className,
  titleClassName,
  descriptionClassName
}: Props) {
  return (
    <div className={cn("xs:max-w-[720px] mx-auto text-center", className)}>
      <h2
        className={cn(
          "xs:text-3xl xs:leading-9 text-2xl leading-7 font-medium tracking-tight",
          titleClassName
        )}
      >
        {title}
      </h2>

      {description ? (
        <p
          className={cn(
            "text-paragraph xs:leading-7 max-xs:text-xs mt-3 leading-4",
            descriptionClassName
          )}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}
